<template>
    <v-app id="inspire">
        <v-navigation-drawer
                v-if="!notShowTemplate"
                v-model="drawer"
                app
        >
            <navigation-menu
                    :items="getItems"
                    @open-chat="$refs.chat.$refs.windowChat.openChat()"
            ></navigation-menu>
            <!--
            <visual-menu class="ma-3">
                <visual-menu-item
                        active
                        :to="{name: 'article', params: {id: 'it-is-me'}}"
                >
                    <div style="font-size: 16px">дело</div>
                    <div>во мне</div>
                </visual-menu-item>
                <visual-menu-item
                        active
                        :to="{name: 'article', params: {id: 'business-is'}}"
                >
                    <div>бизнес</div>
                    <div style="font-size: 16px">это</div>
                </visual-menu-item>
                <visual-menu-item
                        active
                        :to="{name: 'targets'}"
                >
                    <div style="font-size: 16px; padding-bottom: 2px">цели</div>
                </visual-menu-item>
                <visual-menu-item
                        active
                        :to="{name: 'article', params: {id: 'people-targets'}}"
                >
                    <div style="font-size: 16px; padding-bottom: 2px">люди</div>
                    <div>цели</div>
                </visual-menu-item>
            </visual-menu>
            -->
        </v-navigation-drawer>

        <v-app-bar
                v-if="$vuetify.breakpoint.mdAndDown && !notShowTemplate && !$vuetify.breakpoint.xsOnly"
                app
                color="primary"
                dark
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title @click="clickLogo" style="font-weight: 300;">uday.club</v-toolbar-title>
        </v-app-bar>

        <extra-mobile-menu
                v-if="!notShowTemplate && $vuetify.breakpoint.xsOnly"
        ></extra-mobile-menu>

        <mobile-menu
                v-if="!notShowTemplate && $vuetify.breakpoint.xsOnly"
                :items="getItems"
        ></mobile-menu>

        <v-content>
            <v-container
                    fluid
                    :class="{
                        'fill-height': notShowTemplate,
                        'container-mobile': $vuetify.breakpoint.xsOnly,
                        'container_simple': $route.name === 'index',
                    }"
                    class="container-custom"
            >
                <div
                        v-if="!notShowTemplate && !$vuetify.breakpoint.xsOnly"
                        class="d-flex justify-space-between flex-wrap"
                        :class="{
                            'pb-4': !$vuetify.breakpoint.mdAndDown,
                            'pb-3': $vuetify.breakpoint.mdAndDown
                        }"
                >
                    <breadcrumbs></breadcrumbs>
                    <div v-if="!$vuetify.breakpoint.mdAndDown" class="top-nav">
                        <v-btn
                                icon
                                :to="{name: 'profile'}"
                                elevation="0"
                        >
                            <v-icon>mdi-account</v-icon>
                        </v-btn>
                        <v-btn icon class="ml-2" @click="logout()" elevation="0">
                            <v-icon>mdi-logout-variant</v-icon>
                        </v-btn>
                    </div>
                </div>
                <notification
                  v-if="!notShowTemplate && $store.state.user.notifications.length > 0"
                  class="pb-3"
                  @open-chat="$refs.chat.$refs.windowChat.openChat()"
                ></notification>
                <router-view :key="$store.state.common.contentReload"></router-view>
            </v-container>
            <Footer
                    v-if="!notShowTemplate && !$vuetify.breakpoint.xsOnly"
                    @open-close-chat="$refs.chat.$refs.windowChat.openChat()"
            ></Footer>
        </v-content>
        <snack-bar></snack-bar>
        <chat v-if="!notShowTemplate" ref="chat"></chat>
    </v-app>
</template>

<script>
    import Breadcrumbs from "./components/ui/Breadcrumbs";
    import Footer from "./components/block/Footer";
    import NavigationMenu from "./components/block/NavigationMenu";
    import SnackBar from "./components/block/SnackBar";
    import Chat from "./components/block/Chat";
    import MobileMenu from "./components/block/MobileMenu";
    import ExtraMobileMenu from "./components/block/ExtraMobileMenu";
    import VisualMenu from "./components/ui/VisualMenu/VisualMenu";
    import VisualMenuItem from "./components/ui/VisualMenu/VisualMenuItem";
    import Notification from "@/components/block/Notification"

    export default {
        components: {Breadcrumbs, Footer, NavigationMenu, SnackBar, Chat, MobileMenu, ExtraMobileMenu,
            VisualMenu, VisualMenuItem, Notification},
        props: {
            source: String
        },
        data: () => ({
            drawer: null,
            notShowTemplate: true,
            year: new Date().getFullYear()
        }),
        watch: {
            $route (){
                this.notShowTemplate = this.$route.name === 'login' ||
                  this.$route.name === 'registration' ||
                  this.$route.name === 'recovery_password' ||
                  this.$route.name === 'new-password' ||
                  this.$route.name === 'index' ||
                  this.$route.name === '404' ||
                  this.$route.name === 'confirm_email';
            }
        },
        computed: {
            getItems() {

                let items = [
                    {icon: 'mdi-calendar-today', text: 'msg.diary', to: {name: 'diary'}, active: false, mobile: true,
                      items: [
                        {text: 'msg.dayPlan', to: {name: 'diary'}, actions: []},
                        {text: 'msg.weekPlan', to: {name: 'week'}, actions: []},
                        {text: 'msg.monthPlan', to: {name: 'month'}, actions: []},
                      ]},
                    {icon: 'mdi-clipboard-check-outline', text: this.isMobile ? 'msg.plan' : 'msg.planning', to: {name: 'projects'}, active: false, mobile: true,
                        items: [
                            {text: 'msg.projects', to: {name: 'projects'}, actions: ['create_project', 'edit_project', 'tasks', 'tasks_report']},
                            {text: 'msg.notes', to: {name: 'notes'}, actions: []}
                        ]},
                    {icon: 'mdi-bullseye-arrow', text: 'msg.targets', to: {name: 'targets'}, mobile: true,
                      items: [
                        {text: 'msg.my', to: {name: 'targets'}, actions: ['targets_diary']},
                        {text: 'msg.feed', to: {name: 'feed'}, actions: []},
                      ],
                    },
                    {icon: 'mdi-currency-usd', text: 'msg.finance', to: {name: 'transactions'}, active: false, mobile: true,
                        items: [
                            {text: 'msg.transactions', to: {name: 'transactions'}, actions: ['create_transaction', 'edit_transaction', 'transfer']},
                            {text: 'msg.accounts', to: {name: 'accounts'}, actions: ['create_account', 'edit_account']},
                            {text: 'msg.groups', to: {name: 'groups'}, actions: ['create_group', 'edit_group']},
                            {text: 'msg.monthBudget', to: {name: 'month_budget'}, actions: ['create_month_budget', 'edit_month_budget']},
                        ]
                    },
                    // {icon: 'mdi-newspaper-variant-outline', text: 'msg.feed', to: {name: 'feed'}, mobile: false},
                    {icon: 'mdi-apps', text: 'msg.other', to: {name: 'other'}, /*show: this.$vuetify.breakpoint.xsOnly,*/ mobile: true,
                      items: [
                          // {text: 'msg.feed', to: {name: 'feed'}, actions: []},
                          // {text: 'msg.curator', to: {name: 'curator'}, actions: []},
                          // {text: 'msg.profile', to: {name: 'profile'}, actions: []}
                      ]
                    },
                    {icon: 'mdi-logout-variant', text: 'msg.logout', clickFunc: this.logout, show: this.$vuetify.breakpoint.mdAndDown, mobile: false}
                ];

                items.forEach((item, key) => {
                    if (item.items === undefined) return;
                    for (let subKey in item.items) {
                        items[key].active = item.items[subKey].to.name === this.$route.name;
                        if (items[key].active) break;
                        for (let _key in item.items[subKey].actions) {
                            if (item.items[subKey].actions[_key] === this.$route.name) {
                                items[key].active = true;
                                break;
                            }
                        }
                        if (items[key].active) break;
                    }
                });

                return items.filter(v => v.show === undefined || v.show === true);
            }
        },
        methods: {
            clickLogo() {
                if (this.$route.name === 'diary') {
                    this.$store.commit('contentReload');
                } else {
                    this.$router.push({name: 'diary'});
                }
            }
        },
        created() {
            if (this.$store.state.user.isLogin === "true") {
                this.$socket.connecting();
            }
        }
    }
</script>

<style lang="scss">
    .container {

        &.container_simple {
          padding: 0 !important;
          display: block !important;
        }
        &.container-custom {
            flex: 1 0 auto;
            padding-left: 20px;
            padding-right: 20px;
        }
        &.container-mobile{
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 16px;
        }
    }
    .top-nav {
        min-width: 80px;
    }
</style>
